/**
 * Extract the local part of an email address (before @).
 */
export function emailLocalPart(email) {
  if (!email || typeof email !== 'string') {
    return '';
  }
  const trimmed = email.trim();
  const atIndex = trimmed.indexOf('@');
  if (atIndex <= 0) {
    return '';
  }
  return trimmed.slice(0, atIndex);
}
